<template>

<div class="1Wontainer" style="padding-top: 1rem;">
 
	<div class="row">
		<div class="col-lg-8">
			<div class="element-wrapper content-box" style="padding-bottom: 0px;padding-top: 0px;">
				<h6 class="element-header" style="
    margin-bottom: 0rem;">NEW TASK</h6>
			</div>
    <div class="support-index content-box ">
			 <!-- add panel-fullscreen for fullscreen -->
      <div class="support-ticket-content-w folded-info">

        <div class="support-ticket-content ">
          <div class="ticket-thread">
<div class="element-box " style="-webkit-box-shadow: none; box-shadow: none;">
	
	<form>
		<!--	<h5 class="form-header">New task</h5> -->
		<!--
		<div class="form-desc">Discharge best employed your phase each the of shine. Be met even reason consider logbook
			redesigns. Never a turned interfaces among asking</div>
		-->
		<div class="form-group">
			<!-- label for=""> Title</<!-->
			<h2 v-if="!editMode" class="form-header strong">An epic thing to do</h2>
			<h5 v-if="editMode" class="form-header">Title</h5>
			<input v-if="editMode" class="form-control" placeholder="Enter task title" type="text">
		</div>
		<div class="form-group">
			<p v-if="!editMode" >An epic description,
				asd
				asd
				as
				dad
				asd
			</p>
			<h5 v-if="editMode" class="form-header">Description</h5>
			<!-- <label for=""> Description</label> -->
			<quill-editor v-if="editMode" v-model="content" ref="myQuillEditor" :options="editorOption" @blur="onEditorBlur($event)"
				@focus="onEditorFocus($event)" @ready="onEditorReady($event)">
			</quill-editor>
		</div>


<div class="element-wrapper" style="padding-top: 1rem;padding-bottom: 0;">
	<h6 class="element-header">Add your comment, Martin</h6>
<div class="form-group">
			<quill-editor v-model="content" ref="myQuillEditor" :options="editorOption" @blur="onEditorBlur($event)"
				@focus="onEditorFocus($event)" @ready="onEditorReady($event)">
			</quill-editor>
			<div class="form-buttons-w" style="border-top: none;"><button class="btn btn-primary" type="submit">
				Comment</button><button class="btn btn-success" type="submit"> Resolve with comment</button><button
				class="btn btn-danger" type="submit"> Close with comment</button></div>
		</div>
</div>
		



		<div v-if="editMode" class="form-buttons-w" style="border-top: none;"><button class="btn btn-primary" type="submit">
				Submit</button><button class="btn btn-success" type="submit"> Resolve with comment</button><button
				class="btn btn-danger" type="submit"> Close with comment</button></div>

	</form>
</div>
<!-- comment start -->
<div class="element-box highlight" style="-webkit-box-shadow: none; box-shadow: none;">
        <div class="1support-ticket-content">
          <div class="1ticket-thread">
            <div class="ticket-reply highlight" v-for="item in notes" :key="item.id">
              
              <div class="ticket-reply-info"><a class="author with-avatar" href="#"><span>{{item.s | formatSource}}</span></a><span class="info-data"><span class="label">commented on</span><span class="value">{{item.up | formatAsWrote}} </span></span>
                
                <div class="actions" style="font-size: initial; color: #636c72;">
                  {{item.up | formatAsAge}} ago
                </div>
              </div>
              <div class="ticket-reply-content">
                <p style="white-space: pre-wrap;">{{item.e}}</p>
              </div>              
            </div>
          </div>
        </div>


</div>
<!-- comment end -->


<!--
<div style="background-color: #fff6d7;">
asd
</div>
-->        
					<!---	
            <div class="ticket-reply highlight" v-for="item in notes" :key="item.id">
              
              <div class="ticket-reply-info"><a class="author with-avatar" href="#"><span>{{item.s | formatSource}}</span></a><span class="info-data"><span class="label">wrote on</span><span class="value">{{item.up | formatAsWrote}} </span> <span class="label">&nbsp;about</span> <a class="author with-avatar" v-on:click.prevent="loadLead(item.leadId)" href="#">{{item.firstName}} {{item.surName}} and {{item.hotelName}}</a></span>
                
                <div class="actions" style="font-size: initial; color: #636c72;">
                  {{item.up | formatAsAge}} ago
                </div>
              </div>
              <div class="ticket-reply-content">
                <p style="white-space: pre-wrap;">{{item.e}}</p>
              </div>              
            </div>
						-->
          </div>
        </div>
      </div>
    </div>


		</div>
		<div class="col-lg-4">
<div class="element-wrapper">
	<h6 class="element-header">STATUS</h6>
	<div class="element-box-tp">
		<div class="profile-tile" style="border-bottom: none;">
			
			<div class="profile-tile-meta">
				<ul>
					<li>Last Login:<strong>Online Now</strong></li>
					<li>Tickets:<strong><a href="apps_support_index.html">12</a></strong></li>
					<li>Response Time:<strong>2 hours</strong></li>
				</ul>
				<div class="pt-btn"><a class="btn btn-danger btn-sm" href="apps_full_chat.html">Close</a><a class="btn btn-success btn-sm" href="apps_full_chat.html">Resolve</a></div>
				<div class="pt-btn"><a class="btn btn-info btn-sm" @click.prevent="editMode = !editMode">Edit mode</a></div>
			</div>
		</div>
		<h6 class="element-header">MILESTONE</h6>
		<div class="profile-tile"><a class="profile-tile-box" href="users_profile_small.html">
				<div class="pt-avatar-w"><img alt="" src="img/avatar3.jpg"></div>
				<div class="pt-user-name">Ben Gossman</div>
			</a>
			<div class="profile-tile-meta">
				<ul>
					<li>Last Login:<strong>Offline</strong></li>
					<li>Tickets:<strong><a href="apps_support_index.html">9</a></strong></li>
					<li>Response Time:<strong>3 hours</strong></li>
				</ul>
				<div class="pt-btn"><a class="btn btn-secondary btn-sm" href="apps_full_chat.html">Send Message</a></div>
			</div>
		</div>
		<h6 class="element-header">DUE DATE</h6>
		<div class="profile-tile"><a class="profile-tile-box" href="users_profile_small.html">
				<div class="pt-avatar-w"><img alt="" src="img/avatar3.jpg"></div>
				<div class="pt-user-name">Ben Gossman</div>
			</a>
			<div class="profile-tile-meta">
				<ul>
					<li>Last Login:<strong>Offline</strong></li>
					<li>Tickets:<strong><a href="apps_support_index.html">9</a></strong></li>
					<li>Response Time:<strong>3 hours</strong></li>
				</ul>
				<div class="pt-btn"><a class="btn btn-secondary btn-sm" href="apps_full_chat.html">Send Message</a></div>
			</div>
		</div>
		<h6 class="element-header">TAGS</h6>
		<div class="profile-tile"><a class="profile-tile-box" href="users_profile_small.html">
				<div class="pt-avatar-w"><img alt="" src="img/avatar3.jpg"></div>
				<div class="pt-user-name">Ben Gossman</div>
			</a>
			<div class="profile-tile-meta">
				<ul>
					<li>Last Login:<strong>Offline</strong></li>
					<li>Tickets:<strong><a href="apps_support_index.html">9</a></strong></li>
					<li>Response Time:<strong>3 hours</strong></li>
				</ul>
				<div class="pt-btn"><a class="btn btn-secondary btn-sm" href="apps_full_chat.html">Send Message</a></div>
			</div>
		</div>
	</div>
</div>
		</div>
	</div>
	<!-- dash started -->

	<!-- dash end -->


  <div class="row">
    <div class="col-lg-12">
      <!-- notes start -->
		<!--	
    <div class="support-index content-box">
      <div class="support-ticket-content-w folded-info">
        <div class="support-ticket-content">
          <div class="ticket-thread">
            <div class="ticket-reply highlight" v-for="item in notes" :key="item.id">
              
              <div class="ticket-reply-info"><a class="author with-avatar" href="#"><span>{{item.s | formatSource}}</span></a><span class="info-data"><span class="label">wrote on</span><span class="value">{{item.up | formatAsWrote}} </span> <span class="label">&nbsp;about</span> <a class="author with-avatar" v-on:click.prevent="loadLead(item.leadId)" href="#">{{item.firstName}} {{item.surName}} and {{item.hotelName}}</a></span>
                
                <div class="actions" style="font-size: initial; color: #636c72;">
                  {{item.up | formatAsAge}} ago
                </div>
              </div>
              <div class="ticket-reply-content">
                <p style="white-space: pre-wrap;">{{item.e}}</p>
              </div>              
            </div>
          </div>
        </div>
      </div>
    </div>
		-->
<!-- notes end -->

    </div>
  </div>
</div>


</template>
<style>
.element-box, .invoice-w, .big-error-w {
    -webkit-animation-name: none;
    animation-name: none;
    /* -webkit-animation-duration: 1s; */
    /* animation-duration: 1s; */
}
</style>

<script>
var groupBy = require('lodash.groupby')
import axios from 'axios'
import * as moment from 'moment';
import store from './../store'
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'


function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}
// https://codepen.io/lukezak/pen/rVZMgv
// fullscreen

// https://github.com/surmon-china/vue-quill-editor
// quill
export default {
	name: 'Notes',
	components: {
    quillEditor
  },
  filters: {
    formatAsAge: function (value) {
      if (value === 0 || value == undefined) {
        return '~'
      }
      return moment(value).fromNow(true)
    },
    formatAsWrote: function (val) {
      return moment(val).format('dddd MMMM Do YYYY, h:mm')
      // Tuesday Jan 15, 2019 at 17:42
    },
    formatSource: function (val) {
      if (val === 3) {
        return 'Martin'
      }
      if (val === 2) {
        return 'Jeissy'
      }
      if (val === 4) {
        return 'Lucie'
      }

    },
    truncate20: function (val) {
      if (val === undefined) return ''
      return val.substring(0,20)
    },
    getType: function (val) {
      if (val === 1) {
        return '<i class="icon-feather-eye"></i>'
      }
      if (val === 2) {
        return '<i class="icon-feather-phone-call" style="color: #6f42c1;"></i>'
      }
      if (val === 3) {
        return '<i class="icon-feather-video" style="color: #5bc0de;"></i>'
      }
      if (val === 4) {
        return '<i class="icon-feather-message-circle" style="color: #fd7e14;"></i>'
      }
    },
    formatAsDate: function (value) {
        return moment(value).format('LLL')
    },
    capitalize: function (value) {
        if (value == undefined) {
          return ''
        }
        return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
    },
    activityDay: function (value) {
      /* 21st Jan, 2019 Wednesday */
      // console.log(value)
      return moment(value).format('Do MMM YYYY dddd')
    },
    activityTime: function (value) {

      return moment(value).format('HH:mm')
    }

  },
  data () {
    return {
			editMode: false,
			content: '',
        editorOption: {
					theme: 'snow',
					placeholder: 'Compose an epic...',
          modules: {
            toolbar: [
              ['bold', 'italic'],
              ['blockquote', 'code-block'],
              [{ 'header': 1 }, { 'header': 2 }],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
             
              [{ 'indent': '-1' }, { 'indent': '+1' }],
             
              ['clean'],
              ['link', 'image', 'video']
						]
					}
				},
      items: [],
      notes: [
        {s: 2, e: 'e' ,up:1547705449, leadId: '', firstName: '', surName: '', hotelName: ''}
      ]
    }
  },
  methods: {
    loadLead (value) {
      console.log('loading', value)
      //:to="{name: 'Lead', params: {id: data.item.id}}"
      this.$router.push({name: 'Lead', params: {id: value}})
    },
    fullName (value) {
      return `${value.first} ${value.last}`
    },
    act () {
      console.log('act')
    }
  },
  mounted () {
    this.act()
    axios
      .get(store.state.apiUrl+'crmnotes')
      .then(response => {
          this.notes = response.data          
          //tableData.push (obj)
        })
  }
}
</script>
<style>
.ql-container {
    font-size: 1rem;
}
.ql-editor{
    min-height:200px;
}
.panel-fullscreen {
    display: block;
    z-index: 9999;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    overflow: auto;
}
</style>